const serverSide = typeof window === 'undefined'

export const navigateToPage = (path: string) => {
  if (serverSide) return
  window.location.href = path
}
